// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"7be4a78efb385fd4","253":"9d93e4c7de7c0de4","626":"48778e4c2c9bbfef","696":"8dbe012d548f20bf","860":"d2f27bb1d556bf2f"}[chunkId] + ".js";
};